import { useSnapshot } from 'valtio'
import styles from './index.module.less'
import { assistantAction, assistantState, chatAction } from '@/store'
import { Spin } from 'antd'
import { useAgentChat } from '@/hooks/useAgentChat'
import { useEffect } from 'react'
import ArrowRightIcon from '@/assets/images/assistant/arrow_right_icon.svg?react'
import { cn } from '@/utils/css'
interface IProps {
  related: string[]
  onUserSubmit: (text: string) => void
  className?: string | null
}

export default function QuestionRecommend({
  related,
  onUserSubmit,
  className,
}: IProps) {
  return (
    <div className={cn(styles.relatedContainer, className)}>
      <div className={styles.related}>
        {/* <div className="pb-2">猜您想问：</div> */}
        <div className={cn('flex gap-[4px] flex-col max-w-[100%]', className)}>
          {related?.map((text: string, index: number) => (
            <div
              className={cn(styles.relatedItemWrapper, className)}
              key={index}
            >
              <div
                className={styles.relatedItem}
                onClick={() => {
                  onUserSubmit(text)
                }}
              >
                <span>{text}</span>
                <ArrowRightIcon className="w-4 h-4 flex-shrink-0" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
